import { Paper, Typography } from "@mui/material";
import { LabDataItem } from "../../Types/LabData";
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
    Legend, ResponsiveContainer,
} from "recharts";
import CustomTooltip from "./CustomTooltip";

function GraphBase({ labData = [] }: { labData?: LabDataItem[] }) {

    const sortedData = [...labData].sort((a, b) =>
        new Date(a.dateSampled).getTime() - new Date(b.dateSampled).getTime()
    );

    return (
        <Paper elevation={3} sx={{ p: 2, borderRadius: 2 }}>
            <Typography variant="h6" gutterBottom>
                Glucose and Sucrose Levels Over Time
            </Typography>

            <ResponsiveContainer width="100%" height={400}>
                <LineChart
                    data={sortedData}
                    margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                        dataKey="dateSampled"
                        label={{ value: 'Time', position: 'insideBottom', offset: 20 }}
                        tickFormatter={(dateSampled: any) => new Date(dateSampled).toLocaleDateString()}
                        height={60} 
                        tick={{ fontSize: 12 }}
                        padding={{ left: 10, right: 10 }}
                    />
                    {/* Left Y-axis for Glucose */}
                    <YAxis
                        yAxisId="glucose"
                        orientation="left"
                        stroke="#FF0000"
                        label={{ value: '% Glucose (FW)', angle: -90, position: 'insideLeft', dy: 80, offset: -5 }}
                        domain={[0, 0.2]}
                    />
                    {/* Right Y-axis for Sucrose */}
                    <YAxis
                        yAxisId="sucrose"
                        orientation="right"
                        stroke="#FFBB00"
                        label={{ value: 'Sucrose Rating (%FW x 10)', angle: 90, position: 'insideRight', dy: 100 }}
                        domain={[0, 2]} // Adjust scale
                    />
                    <Tooltip content={CustomTooltip} />
                    <Legend />
                    <Line
                        yAxisId="glucose"
                        type="monotone"
                        dataKey="glucose"
                        stroke="#FF0000"
                        activeDot={{ r: 8 }}
                        name="Glucose"
                    />
                    <Line
                        yAxisId="sucrose"
                        type="monotone"
                        dataKey="sucrose"
                        stroke="#FFBB00"
                        name="Sucrose"
                    />
                </LineChart>
            </ResponsiveContainer>
        </Paper>
    );
}

export default GraphBase;